var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1267 1267"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1267 78.8 1188.2 0 633.5 554.8 78.8 0 0 78.8l554.7 554.7L0 1188.3l78.8 78.7 554.7-554.7 554.7 554.7 78.8-78.7-554.7-554.8z"
  })));
};
export default SvgClose;